import React from "react";
import PropTypes from "prop-types";
import P from "../../Typography/P";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "../../Radio";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "../../FormControlLabel";
import Tooltip from "@material-ui/core/Tooltip";
import dictionary from "../../../../dictionary";

import styles from "../radio-group.module.scss";

function PhoneCases(props) {
  const {name, content: allContent, onChange, current} = props;
  const softTouchContent = allContent.filter(({value}) =>
    value.includes(`soft_touch`)
  );
  const leatherContent = allContent.filter(({value}) =>
    value.includes(`leather`)
  );
  const siliconeContent = allContent.filter(({value}) =>
    value.includes(`silicone`)
  );
  return [
    {legend: `Soft touch`, content: softTouchContent},
    {legend: `Кожа`, content: leatherContent},
    {legend: `Силикон`, content: siliconeContent}
  ].map(
    ({legend, content}) =>
      content.length > 0 && (
        <div key={legend} className={styles.root}>
          <FormControl component="fieldset" className={styles.fieldset}>
            <FormLabel component="legend">
              <P size="small" className={styles.legend}>
                {legend}
              </P>
            </FormLabel>
            <RadioGroup
              defaultValue={current}
              value={current}
              aria-label={name}
              className={styles.group}
              onChange={(event) => onChange(name, event.target.value)}
            >
              {content.map(({value, label, disabled}) => (
                <Tooltip
                  key={`${name}-${value}`}
                  title={dictionary.item[value]}
                >
                  <FormControlLabel
                    className={styles.radio}
                    key={value}
                    value={value}
                    control={
                      <Radio disabled={disabled} checked={current === value} />
                    }
                    label={
                      <span
                        className={styles.labelImage}
                        style={{backgroundImage: `url(${label})`}}
                      />
                    }
                  />
                </Tooltip>
              ))}
            </RadioGroup>
          </FormControl>
        </div>
      )
  );
}

PhoneCases.propTypes = {
  productName: PropTypes.string,
  department: PropTypes.string,
  category: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      difference: PropTypes.number
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func
};

export default PhoneCases;
